import React from 'react'
import { FieldErrorsImpl } from 'react-hook-form'

interface IProps {
    error?: string
}

export type IArrayError = FieldErrorsImpl<{
    [attr: string]: string
}>

export default function ErrorForm(props: IProps): React.ReactElement {
    return <div className="error-box">{props.error ? <p className="error-msg">* {props.error}</p> : <></>}</div>
}
